// extracted by mini-css-extract-plugin
module.exports = {"leadership__hero":"TextSectionWithButtonAndImage_leadership__hero__VBHOI","leadership__hero--bannerDesign":"TextSectionWithButtonAndImage_leadership__hero--bannerDesign__ecJsV"};